<template>
  <div class="redPacketRecord">
    <!-- 选择区 -->
    <div class="selectionArea search_box">

      <!-- <span class="title">商户号名称</span> -->
      <el-input
        v-model="parameter.merchant_name"
        style="width:200px"
        placeholder="商户号名称"
      />

      <!-- <span class="title">绑定状态</span> -->
      <el-select v-model="parameter.status" placeholder="请选择状态">
        <el-option
          v-for="item in status_s"
          :key="item.id"
          :label="item.value"
          :value="item.id"
        />
      </el-select>

      <!-- <span class="title">商户id</span> -->
      <el-input v-model="parameter.merchant_id" style="width:200px" placeholder="请输入商户id" />
      <el-button icon="el-icon-search" type="primary" @click="(parameter.page = 1),(getData())">搜索</el-button>
      <el-button icon="el-icon-refresh-left" type="info" @click="reset">重置</el-button>

      <el-button
        type="success"
        icon="el-icon-s-help"
        size="medium"
        style="position: absolute;right: 0px;bottom: 0px;"
        @click="dialogVisible = true"
      >创建商户号</el-button>
    </div>

    <!-- 主体区 -->
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="merchant_id"
          label="商户号id"
          width="130"
          align="center"
        />
        <el-table-column
          prop="merchant_name"
          label="商户号名称"
          width="200"
          align="center"
        />
        <el-table-column
          prop="certificate_serial"
          label="APIv2密钥"
          width="200"
          align="center"
        />
        <el-table-column
          prop="certificate_file_path"
          label="证书路径"
          width="200"
          align="center"
        />
        <el-table-column
          prop="private_key_file_path"
          label="私钥证书路径"
          width="200"
          align="center"
        />
        <el-table-column
          prop="created_at_text"
          label="创建时间"
          width="160"
          align="center"
        />
        <el-table-column
          prop="available_amount"
          label="余额(元)"
          width="80"
          align="center"
        />
        <el-table-column
          prop="amount_alert"
          label="余额提醒阈值(元)"
          width="80"
          align="center"
        />
        <el-table-column
          prop="status_text"
          label="状态"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <i v-if="scope.row.status == 1" class="el-icon-warning defaultrse" />
            <i v-if="scope.row.status == 2" class="el-icon-success defaultr" />
            <i v-if="scope.row.status == 3" class="el-icon-error stopew" />
            {{ scope.row.status_text }}
          </template>
        </el-table-column>
        <el-table-column
          prop="creator"
          label="创建人"
          align="center"
        />
        <el-table-column
          label="操作"
          align="center"
          width="300"
        >
          <template scope="scope">
            <el-button :type="scope.row.status === 3 ? 'success' :'danger'" size="mini" @click="modifyMerchant(scope.row)">{{ scope.row.status === 3 ? '启用' : scope.row.status === 2 ? '禁用' : '启用' }}</el-button>
            <el-button size="mini" type="primary" @click="setvacancies(1,scope.row)">设置余额</el-button>
            <el-button size="mini" type="warning" @click="setvacancies(2,scope.row)">设置阈值</el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <PaginationRight
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />

    <el-dialog
      title="创建商户号"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <MerchantNo v-if="dialogVisible" @determine="determine" @close="dialogVisible = false" />
    </el-dialog>
    <el-dialog
      :title="type === 1 ? '设置余额' : '设置阈值'"
      :visible.sync="setdialogVisible"
      :close-on-click-modal="false"
      width="30%"
      @close="sethandleClose"
    >
      <el-input v-model="value" type="number" min="0" style="width:200px" :placeholder="type === 1 ? '请输入余额' : '请输入阈值'" @blur="forcechapterblur" />
      <div style="margin-top:30px">
        <el-button type="primary" @click="serclickr">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { commodityNumberList, modifyMerchantIDStatus, createMerchantID, updataamount } from '@/api/weChatMerchants.js'
import PaginationRight from '@/components/PaginationRight'
import MerchantNo from './components/MerchantNo.vue'
export default {
  name: 'Merchantlist',
  components: {
    PaginationRight,
    MerchantNo
  },
  data() {
    return {
      parameter: {
        page: 1, // 页码
        pageSize: 10, // 页数
        merchant_name: null, // 商品号名称
        status: null, // 状态
        merchant_id: null // 	商户id
      },
      status_s: [{ id: 1, value: '添加未生效' }, { id: 2, value: '已经生效 ' }, { id: 3, value: '禁用' }],
      tableData: [],
      total: null,
      loading: false,
      dialogVisible: false,
      type: null,
      value: '',
      setdialogVisible: false,
      ids: null
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const data = await commodityNumberList({ ...this.parameter })
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    fetchPageSizeone(e) {
      this.parameter.pageSize = e
      this.getData()
    },
    fetchCurrentPageone(e) {
      this.parameter.page = e
      this.getData()
    },
    reset() {
      this.parameter = {
        page: 1, // 页码
        pageSize: 10, // 页数
        merchant_name: null, // 商品号名称
        status: null, // 状态
        merchant_id: null // 	商户id
      }
      this.getData()
    },
    modifyMerchant(row) {
      const text = row.status === 3 ? '是否推向启用' : row.status === 2 ? '是否推向禁用' : '是否推向启用'
      const tips = row.status === 3 ? '推向启用成功' : row.status === 2 ? '推向禁用成功' : '推向启用成功'
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await modifyMerchantIDStatus({ id: row.id, merchant_id: row.merchant_id, status: row.status === 3 ? 2 : 3 })
        this.getData()
        this.$message({
          type: 'success',
          message: tips
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    handleClose(done) {
      this.dialogVisible = false
    },

    async determine(query) {
      console.log('query', query)
      if (query.merchant_id == null) {
        this.$message.error('请填写商户号id')
        return
      }
      if (query.merchant_name == null) {
        this.$message.error('请填写商户号名称')
        return
      }
      if (query.certificate_serial == null) {
        this.$message.error('请填写证书序列号')
        return
      }
      if (query.certificate_file_path == null) {
        this.$message.error('请上传证书')
        return
      }
      if (query.private_key_file_path == null) {
        this.$message.error('请上传私钥')
        return
      }
      await createMerchantID(query)
      this.$message({
        type: 'success',
        message: '商户号创建成功'
      })
      this.getData()
      this.dialogVisible = false
    },
    setvacancies(type, item) {
      this.setdialogVisible = true
      this.type = type
      this.ids = item.id
      if (this.type === 1) {
        this.value = item.available_amount
      } else {
        this.value = item.amount_alert
      }
    },
    sethandleClose() {
      // this.value = ''
      console.log('关闭')
    },
    forcechapterblur() {
      // eslint-disable-next-line eqeqeq
      if (this.value < 0 && this.value != '') {
        this.value = 1
      }
      // // 判断不能输入小数点
      // const str = '' + this.gzinput
      // if (str.indexOf('.') !== -1) {
      //   console.log('小鼠了')
      //   this.gzinput = 1
      // }
    },
    async serclickr() {
      if (this.value === '') {
        this.$message({
          type: 'error',
          message: '请输入值'
        })
        return
      }
      const data = await updataamount({
        id: this.ids,
        type: this.type,
        value: this.value
      })
      this.setdialogVisible = false
      this.getData()
      console.log('data', data)
    }
  }
}
</script>

<style scoped>
.redPacketRecord{
  width: 95%;
  margin: 0 auto;
  margin-top: 50px;
}

.selectionArea{
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.item{
     display: flex;
     align-items: center;
     margin-right: 30px;
     margin-bottom: 10px;
}

.item .title{
  display: inline-block;
  margin-right: 10px;
  font-size: 15px;
  color: rgb(165, 157, 145);
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}

</style>
